import { ProjectActionTypes } from './project.types'

//Add Project
export const addProjectRequest = data => ({
    type: ProjectActionTypes.ADD_PROJECT_REQUEST,
    payload: data
})

export const addProjectRequestSuccess = data => ({
    type: ProjectActionTypes.ADD_PROJECT_REQUEST_SUCCESS,
    payload: data
})

export const addProjectRequestError = data => ({
    type: ProjectActionTypes.ADD_PROJECT_REQUEST_ERROR,
    payload: data
})

export const addProjectRequestStatus = data => ({
    type: ProjectActionTypes.ADD_PROJECT_REQUEST_STATUS,
    payload: data
})

//Project List
export const projectListRequest = data => ({
    type: ProjectActionTypes.PROJECT_LIST_REQUEST,
    payload: data
})

export const projectListRequestSuccess = data => ({
    type: ProjectActionTypes.PROJECT_LIST_REQUEST_SUCCESS,
    payload: data
})

export const projectListRequestError = data => ({
    type: ProjectActionTypes.PROJECT_LIST_REQUEST_ERROR,
    payload: data
})

//Project Detail
export const projectDetailRequest = data => ({
    type: ProjectActionTypes.PROJECT_DETAIL_REQUEST,
    payload: data
})

export const projectDetailRequestSuccess = data => ({
    type: ProjectActionTypes.PROJECT_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const projectDetailRequestError = data => ({
    type: ProjectActionTypes.PROJECT_DETAIL_REQUEST_ERROR,
    payload: data
})

//Update Project Detail
export const updateProjectDetailRequest = data => ({
    type: ProjectActionTypes.PROJECT_UPATE_DETAIL_REQUEST,
    payload: data
})

export const updateProjectDetailRequestSuccess = data => ({
    type: ProjectActionTypes.PROJECT_UPATE_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const updateProjectDetailRequestError = data => ({
    type: ProjectActionTypes.PROJECT_UPATE_DETAIL_REQUEST_ERROR,
    payload: data
})

export const updateProjectDetailRequestStatus = data => ({
    type: ProjectActionTypes.PROJECT_UPATE_DETAIL_REQUEST_STATUS,
    payload: data
})

//Project Assign Employee
export const projectAssignEmployeeRequest = data => ({
    type: ProjectActionTypes.PROJECT_ASSIGN_EMPLOYEE_REQUEST,
    payload: data
})

export const projectAssignEmployeeRequestSuccess = data => ({
    type: ProjectActionTypes.PROJECT_ASSIGN_EMPLOYEE_REQUEST_SUCCESS,
    payload: data
})

export const projectAssignEmployeeRequestError = data => ({
    type: ProjectActionTypes.PROJECT_ASSIGN_EMPLOYEE_REQUEST_ERROR,
    payload: data
})

export const projectAssignEmployeeRequestStatus = data => ({
    type: ProjectActionTypes.PROJECT_ASSIGN_EMPLOYEE_REQUEST_STATUS,
    payload: data
})

//Project Remove Employee
export const projectRemoveEmployeeRequest = data => ({
    type: ProjectActionTypes.PROJECT_REMOVE_EMPLOYEE_REQUEST,
    payload: data
})

export const projectRemoveEmployeeRequestSuccess = data => ({
    type: ProjectActionTypes.PROJECT_REMOVE_EMPLOYEE_REQUEST_SUCCESS,
    payload: data
})

export const projectRemoveEmployeeRequestError = data => ({
    type: ProjectActionTypes.PROJECT_REMOVE_EMPLOYEE_REQUEST_ERROR,
    payload: data
})

export const projectRemoveEmployeeRequestStatus = data => ({
    type: ProjectActionTypes.PROJECT_REMOVE_EMPLOYEE_REQUEST_STATUS,
    payload: data
})

//Request Project
export const requestProjectRequest = data => ({
    type: ProjectActionTypes.REQUEST_PROJECT_REQUEST,
    payload: data
})

export const requestProjectRequestSuccess = data => ({
    type: ProjectActionTypes.REQUEST_PROJECT_REQUEST_SUCCESS,
    payload: data
})

export const requestProjectRequestError = data => ({
    type: ProjectActionTypes.REQUEST_PROJECT_REQUEST_ERROR,
    payload: data
})

export const requestProjectRequestStatus = data => ({
    type: ProjectActionTypes.REQUEST_PROJECT_REQUEST_STATUS,
    payload: data
})

//Reject Employee Request Project
export const rejectEmployeeProjectRequest = data => ({
    type: ProjectActionTypes.REJECT_EMPLOYEE_PROJECT_REQUEST,
    payload: data
})

export const rejectEmployeeProjectRequestSuccess = data => ({
    type: ProjectActionTypes.REJECT_EMPLOYEE_PROJECT_REQUEST_SUCCESS,
    payload: data
})

export const rejectEmployeeProjectRequestError = data => ({
    type: ProjectActionTypes.REJECT_EMPLOYEE_PROJECT_REQUEST_ERROR,
    payload: data
})

export const rejectEmployeeProjectRequestStatus = data => ({
    type: ProjectActionTypes.REJECT_EMPLOYEE_PROJECT_REQUEST_STATUS,
    payload: data
})